import { useState, type FormEvent } from 'react';
import { Link } from 'react-router-dom';

export default function NewsletterCTASection() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [msg, setMsg] = useState('');

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setStatus('loading');
    try {
      const formData = new FormData(e.currentTarget);
      const honeypotVal = (formData.get('contact_alt') as string || '').trim();
      if (honeypotVal) {
        setStatus('success');
        setMsg('订阅成功！感谢您的关注！');
        setEmail('');
        return;
      }
      formData.delete('contact_alt');

      const response = await fetch('https://readdy.ai/api/form/d96fdl7pg5pqhofcuobg', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });
      const responseText = await response.text();
      let parsed;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = {};
      }
      const serverMsg = parsed?.meta?.message || parsed?.message || responseText || '';
      if (response.ok && parsed?.code === 'OK') {
        setStatus('success');
        setMsg('订阅成功！每周精彩韩漫更新不错过！');
        setEmail('');
      } else if (serverMsg.includes('spam')) {
        setStatus('error');
        setMsg('提交出现异常，请稍后重试');
      } else {
        setStatus('error');
        setMsg(serverMsg || '订阅失败，请稍后重试');
      }
    } catch {
      setStatus('error');
      setMsg('网络异常，请稍后重试');
    }
  };

  return (
    <section className="py-10 md:py-14 px-4 md:px-6 bg-background-100">
      <div className="flex flex-col lg:flex-row rounded-2xl overflow-hidden">
        <div className="lg:w-1/2 relative min-h-[250px] lg:min-h-[380px] bg-background-200">
          <img
            src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20reading%20atmosphere%2C%20cozy%20reading%20nook%20with%20warm%20lighting%2C%20bookshelf%20with%20colorful%20manga%20books%2C%20soft%20cream%20and%20beige%20tones%2C%20artistic%20illustration%20style%2C%20inviting%20mood%2C%20painterly%20texture&width=960&height=800&seq=cta-comic-bg&orientation=landscape"
            alt=""
            className="absolute inset-0 w-full h-full object-cover"
            loading="lazy"
          />
          <div className="absolute inset-0 bg-black/20"></div>
          <div className="absolute left-6 bottom-6">
            <p className="text-xs text-white/70 uppercase tracking-widest mb-2">
              JOIN US
            </p>
            <h3 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-white leading-tight">
              加入<br />歪歪漫画
            </h3>
          </div>
        </div>

        <div className="lg:w-1/2 bg-background-50 flex items-center justify-center p-8 md:p-12">
          <div className="text-center max-w-sm">
            <h3 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
              订阅更新通知
            </h3>
            <p className="text-sm text-foreground-600 leading-relaxed mb-6">
              第一时间获取最新韩漫更新、热门推荐和专属福利，每周精彩内容不错过！
            </p>
            <form data-readdy-form="" id="cta-newsletter" onSubmit={handleSubmit} className="space-y-3">
              <input
                type="email"
                name="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="请输入您的邮箱地址"
                required
                className="w-full px-4 py-3 rounded-full bg-background-100 border border-background-200 text-sm text-foreground-800 placeholder:text-foreground-400 outline-none focus:border-primary-300 transition-colors"
              />
              <input
                type="text"
                name="contact_alt"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
                readOnly
                className="form-honeypot"
              />
              <button
                type="submit"
                disabled={status === 'loading'}
                className="w-full flex items-center justify-center gap-2 bg-primary-500 hover:bg-primary-600 text-background-50 px-6 py-3 rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap cursor-pointer disabled:opacity-70"
              >
                {status === 'loading' ? '提交中...' : (
                  <>
                    免费订阅
                    <i className="ri-arrow-right-line"></i>
                  </>
                )}
              </button>
              {status !== 'idle' && (
                <p className={`text-xs ${status === 'success' ? 'text-secondary-600' : 'text-red-500'}`}>
                  {msg}
                </p>
              )}
            </form>
            <p className="text-xs text-foreground-400 mt-3">
              已有 <strong className="text-foreground-700">560万+</strong> 读者加入，立即订阅
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}